module.exports = __webpack_public_path__ + "static/ewallet-7f37f2444b219ea5c0c1651dca54337f.png";